import React from "react";

export default function TermsOfService() {
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-700 dark:text-gray-300">
      <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>

      <p className="mb-4">
        By accessing and using the Village of Hope Child Tracking and
        Development Monitoring System, users agree to comply with the following
        terms and conditions.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Authorized Access</h2>
      <p>
        Only authorized administrators and staff members are permitted to use
        this system. Unauthorized access or misuse of the system is strictly
        prohibited.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">System Usage</h2>
      <ul className="list-disc ml-6">
        <li>Users must maintain accurate and updated records.</li>
        <li>Users must protect login credentials.</li>
        <li>Users must not modify system data without authorization.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Security</h2>
      <p>
        The system implements role-based access control, authentication, and
        activity logging to ensure system security and accountability.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Violation</h2>
      <p>
        Any violation of these terms may result in account suspension or
        termination of access to the system.
      </p>
    </div>
  );
}